import { handleMenuToggle } from "./menuToggle"

// Smooth scrolling for anchor links
document.addEventListener("DOMContentLoaded", function () {
  // Select all anchor links with hash but not just "#"
  const anchorLinks = document.querySelectorAll('a[href*="#"]:not([href="#"])')
  const appHeaderHeight = document.querySelector(".app-header").offsetHeight

  anchorLinks.forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      // Check if we're on the same page
      if (
        location.pathname.replace(/^\//, "") ===
          this.pathname.replace(/^\//, "") &&
        location.hostname === this.hostname
      ) {
        e.preventDefault()

        // Get target element
        const targetId = this.hash.slice(1)
        let target = document.getElementById(targetId)

        if (!target) {
          return
        }

        if (target) {
          handleMenuToggle()

          const targetPosition =
            target.getBoundingClientRect().top +
            window.pageYOffset -
            appHeaderHeight -
            45

          window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
          })
        }
      }
    })
  })

  // Handle hash in URL on page load
  if (location.hash) {
    setTimeout(function () {
      const targetId = location.hash.slice(1)
      const target = document.getElementById(targetId)

      if (target) {
        const targetPosition =
          target.getBoundingClientRect().top +
          window.pageYOffset -
          appHeaderHeight -
          45

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        })
      }
    }, 100) // Small timeout to ensure page is fully rendered
  }
})
